import { render, staticRenderFns } from "./AgentReports.vue?vue&type=template&id=6b9d1e20&"
import script from "./AgentReports.vue?vue&type=script&lang=js&"
export * from "./AgentReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports